// type Props = {
//   selectedApp: string;
// };

import { UseFormReturn } from "react-hook-form";
import { clientOnboardingType } from "@/pages/AppCreation/validator";
import WhiteLogo from "@/components/icons/WhiteLogo";
import useCurrentUserStore from "@/store";
type PropTypes = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<clientOnboardingType, any, undefined>;
};
const reqExpressionBlog = /\bblog\b|\bblog\w*|\w*blog\b|\w*blog\w*/gi;
const Step1ContentPreview = (props: PropTypes) => {
  const { selectedApp } = useCurrentUserStore();
  console.log("🚀 ~ Step1ContentPreview ~ selectedApp:", selectedApp);
  return (
    <div className="bg-primary lg:rounded-[20px] shadow-md p-6 lg:p-10 text-white flex flex-col lg:items-center justify-center h-[calc(100%-0.5rem)] object-cover lg:mt-1">
      <WhiteLogo />
      {selectedApp?.image ? (
        <img
          className="h-auto max-w-[20rem] lg:max-w-[80%]"
          src={selectedApp?.image}
          alt="app-image"
        />
      ) : props.form
          .getValues("step1.appTemplateName")
          ?.match(reqExpressionBlog) ? (
        <img className="h-auto" src="/image.svg" alt="group-icon" />
      ) : (
        <img className="h-auto" src="/step-3-group-icon.png" alt="group-icon" />
      )}
    </div>
  );
};

export default Step1ContentPreview;
